import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import MonthSelector from "./MonthSelector";
import ListViewItem from "./ListViewItem";
import CompareListPhotosModal from "./CompareListPhotosModal";
import { MobileMonthSelector } from "../../../../../parts/MobileMonthSelector";
import PreviewPhotoModal from "./PreviewPhotoModal";
import CompareSelected from "../../../../../parts/CompareSelected";
import { ReportsBackHandler } from "../../components/ReportsBackHandler";
import useIsVisible from "../../../../../hooks/useIsVisible";
import SvgIcon from "../../../../../parts/SvgIcon";

const ListView = ({ locals, comesFromBodyComp }) => {
  const { dailyStats, query } = locals;
  const { name, _id: athleteId } = locals.athlete || locals.activeUser;
  const isCoach = !!locals.athlete;
  const today = query.date ? moment.utc(query.date, 'YYYYMMDD') : moment();
  const organizationCoach = query.organizationCoach || undefined;

  const organizationCoachParam = organizationCoach
    ? `&organizationCoach=${organizationCoach}`
    : "";
  const timelineUrl = isCoach
    ? `/athlete-portal/metrics/progress-photos?date=${moment(today).format(
        "YYYYMMDD"
      )}&athlete=${athleteId}&view=Timeline`
    : `/dashboard/metrics/progress-photos?date=${moment(today).format(
        "YYYYMMDD"
      )}&view=Timeline`;
  const [date, setDate] = useState(today);
  const [listOfPhotos, setListOfPhotos] = useState([]);

  const [selectedPhotos, setSelectedPhotos] = useState([]);
  const [isSelecting, setIsSelecting] = useState(false);

  const [isModalOpened, setIsModalOpened] = useState(false);

  const [previewModalOpened, setPreviewModalOpened] = useState(false);
  const [previewPhoto, setPreviewPhoto] = useState({});
  const ref = useRef();
  const isVisible = useIsVisible(ref);

  const getFilteredStats = (startOfMonth, endOfMonth) => {
    const photos = dailyStats.filter(
      (stat) =>
        stat.bodyPhotos &&
        Object.keys(stat.bodyPhotos).length &&
        stat.utcDate >= startOfMonth &&
        stat.utcDate <= endOfMonth
    );
    return photos;
  };
  const handleReset = () => {
    setIsModalOpened(false);
    setSelectedPhotos([]);
    setIsSelecting(false);
  };
  const selectPhotos = (photo) => {
    if (selectedPhotos.length <= 2) {
      // Add or remove photo based on its selection state
      setSelectedPhotos((prevSelectedPhotos) => {
        if (prevSelectedPhotos.includes(photo)) {
          return prevSelectedPhotos.filter(
            (selectedPhoto) => selectedPhoto !== photo
          );
        }
        return selectedPhotos.length < 2
          ? [...prevSelectedPhotos, photo]
          : prevSelectedPhotos;
      });
    }
  };

  useEffect(() => {
    setListOfPhotos(
      getFilteredStats(
        moment(date).utc().startOf("month").format("YYYYMMDD"),
        moment(date).utc().endOf("month").format("YYYYMMDD")
      )
    );
  }, [date, athleteId]);
  const handlePreviewModal = (type, src) => {
    console.log("clicking photo! ");
    setPreviewPhoto({ type, pictureImg: src });
    setPreviewModalOpened(true);
  };
  return (
    <article role="report-content" id="progress-photos">
      <header>
        <div className="top-header only-show-mobile">
          <ReportsBackHandler title={"Progress Photos"} locals={locals} />
          <MobileMonthSelector date={date} setDate={setDate} />
        </div>
        <div className="flex gap-2 items-center">
          {comesFromBodyComp && (
            <SvgIcon
              classNames="cursor-pointer "
              onClickFn={() => {
                history.back();
              }}
              src={"/img/new-icons/back-button.svg"}
            />
          )}
          <h3 className="mobile-hidden">Progress Photos</h3>
        </div>
        <div ref={ref} role="buttons-container">
          {isSelecting ? (
            <>
              <button data-button-type="secondary" onClick={handleReset}>
                Cancel
              </button>
              <button
                data-button-type="primary"
                disabled={selectedPhotos.length < 2}
                onClick={
                  selectedPhotos.length === 2
                    ? () => setIsModalOpened(true)
                    : null
                }
              >
                Compare
              </button>
            </>
          ) : (
            <>
              <a
                href={`${timelineUrl}${organizationCoachParam}`}
                data-button-type="secondary"
                role="button"
              >
                Timeline View
              </a>
              <button
                data-button-type="primary"
                onClick={() => setIsSelecting(true)}
              >
                Compare Photos
              </button>
            </>
          )}
        </div>
      </header>
      <div id="listview-container">
        <MonthSelector date={date} setDate={setDate} />
        {listOfPhotos.length > 0 && (
          <ul className="photos-list">
            {listOfPhotos.map((item) => (
              <ListViewItem
                key={item._id}
                stat={item}
                choosing={isSelecting}
                selectPhotos={selectPhotos}
                selectedPhotos={selectedPhotos}
                handlePreviewModal={handlePreviewModal}
              />
            ))}
          </ul>
        )}
        {listOfPhotos.length === 0 && <p>No data in the selected period</p>}
      </div>
      {
        <CompareSelected
          label1={"Image 1"}
          label2={"Image 2"}
          selectedItem1={
            selectedPhotos[0]
              ? moment(selectedPhotos[0].date, "YYYYMMDD").format("MMM D,YYYY")
              : null
          }
          selectedItem2={
            selectedPhotos[1]
              ? moment(selectedPhotos[1].date, "YYYYMMDD").format("MMM D,YYYY")
              : null
          }
          compareFunction={() => setIsModalOpened(true)}
          closeFunction={() => setSelectedPhotos([])}
          isTopButtonVisible={isVisible}
          compareName={"Photos"}
          isModalOpened={isModalOpened}
        />
      }
      {isModalOpened && (
        <CompareListPhotosModal
          selectedPhotos={selectedPhotos.sort((a, b) => a.utcDate - b.utcDate)}
          setSelectedPhotos={setSelectedPhotos}
          closeModalAndReset={handleReset}
          closeModal={() => setIsModalOpened(false)}
          sides={["front", "back", "side"]}
        />
      )}
      {previewModalOpened && (
        <PreviewPhotoModal
          toggleModal={() => setPreviewModalOpened(false)}
          photo={previewPhoto}
          dontRefreshOnClose={true}
        />
      )}
    </article>
  );
};

export default ListView;
